<template>
<div>
	<div class="modal error has-text-left" :class="{'is-active' : ErrorModal.active}">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<button class="delete" @click="close()"></button>
			</header>
			<section class="modal-card-body">
				<div class="columns">
					<div class="column is-2">
						<span class="icon is-large has-text-primary is-pulled-left">
							<i class="fa fa-times-circle"></i>
						</span>
					</div>
					<div class="column">
						<p class="title is-4">{{ErrorModal.text}}</p>
					</div>
				</div>
			</section>
			<footer class="modal-card-foot right">
				<a class="button" @click="close()">OK</a>
			</footer>
		</div>
	</div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
	date() {
		return {}
	},
	computed: {
		...mapGetters({
			ErrorModal: 'errorModal/all',
		})
	},
	methods: {
		close() {
			this['errorModal/set'](false)
			this.$bus.$emit('errorModalClose')
		},
		...mapActions([
			'errorModal/set',
		])
	}
}
</script>



// WEBPACK FOOTER //
// ErrorModal.vue?281678c5